import React, { useState } from "react";
import { Link, useNavigate } from "react-router";
import { usePost } from "../../api";
import { IKindredBrandDetail } from "../../interfaces";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { ArrowLeft, Plus } from "react-feather";

export const KindredBrandCreate: React.FC = () => {
  const navigate = useNavigate();
  const createBrand = usePost<IKindredBrandDetail, any>();

  const [name, setName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [logo, setLogo] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState<string | null>(null);

  const canSubmit = name.trim() && !createBrand.loading;

  const handleCreate = async () => {
    setError(null);
    try {
      const result = await createBrand.execute("kindred/brands", {
        data: {
          name: name.trim(),
          countryCode: countryCode || null,
          logo: logo || null,
        },
        comment: comment.trim() || undefined,
      });
      if (result?.id) {
        navigate(`/kindred/brands/${result.id}`);
      }
    } catch (err: any) {
      setError(err?.message || "Failed to create brand");
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Create Brand</h4>
        <Link to="/kindred/brands">
          <Button size="sm" variant="outline-secondary">
            <ArrowLeft size={14} className="me-1" /> Back to Brands
          </Button>
        </Link>
      </div>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <Card.Body>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small mb-0">
                  Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  size="sm"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Brand name"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small mb-0">Country Code</Form.Label>
                <Form.Control
                  size="sm"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  placeholder="e.g. GB"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small mb-0">Logo URL</Form.Label>
                <Form.Control
                  size="sm"
                  value={logo}
                  onChange={(e) => setLogo(e.target.value)}
                  placeholder="https://..."
                />
              </Form.Group>
            </Col>
          </Row>

          <hr />

          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small mb-0">Comment</Form.Label>
                <Form.Control
                  size="sm"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Optional reason for creating..."
                />
              </Form.Group>
            </Col>
            <Col md={6} className="d-flex align-items-end">
              <Button
                variant="primary"
                size="sm"
                disabled={!canSubmit}
                onClick={handleCreate}
              >
                {createBrand.loading ? (
                  <Spinner animation="border" size="sm" className="me-1" />
                ) : (
                  <Plus size={14} className="me-1" />
                )}
                Create Brand
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};
